export const MERGE_SORT = "MergeSort";
export const BUBBLE_SORT = "BubbleSort";
export const QUICK_SORT = "QuickSort";
export const INSERTION_SORT = "InsertionSort";
export const HEAP_SORT = "HeapSort";
export const SELECTION_SORT = "SelectionSort";
export const COUNTING_SORT = "CountingSort";
export const RADIX_SORT = "RadixSort";
export const BUCKET_SORT = "BucketSort";
export const TIM_SORT = "TimSort";
export const TREE_SORT = "TreeSort";
export const COMB_SORT = "CombSort";

export const NUMBER_COLUMNS = 250;
export const PRIMARY_COLOR = "rgb(57, 86, 218)";
export const SECONDARY_COLOR = "green";
export const ANIMATION_SPEED_MS = 1;
